<template>
  <div
    class="overflow-x-auto html-editor"
    v-html="data"
  />
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  data?: string;
}>(), { data: '' });
</script>
